<template>
  <div class="w-full px-6 py-4">
    <div v-if="_service && !serviceResources.length" class="text-center">
      <p class="text-gray-600 m-4 dark:text-gray-300">
        {{ $t('components.service.edit.resources.noResources') }}
      </p>
      <OButton variant="info" @click="handleAddServiceResource">
        {{ $t('components.service.edit.resources.add') }}
      </OButton>
    </div>

    <OTable
      v-if="_service && serviceResources.length"
      class="w-full"
      container-class="border rounded bg-white dark:bg-gray-900 dark:border-gray-800 overflow-hidden"
      :data="serviceResources"
      :headers="[
        {text: $t('general.label')},
        {text: $t('general.quantity')},
        {text: $t('components.service.edit.resources.resourceGroup')},
        {text: $t('components.service.edit.resources.defaultSelection')},
        {text: $t('general.actions')}
      ]"
      :limit="20"
      :title="$t('general.resources')"
      :info="$t('components.service.edit.resources.info')"
      striped
    >
      <template #controls>
        <OButton variant="info" @click="handleAddServiceResource">
          {{ $t('components.service.edit.resources.add') }}
        </OButton>
      </template>

      <template #row="props">
        <td :class="props.tdClass">
          {{ props.row.name }}
        </td>
        <td :class="props.tdClass">
          {{ props.row.quantity || 1 }}
        </td>
        <td :class="props.tdClass">
          {{ props.row.resources ? props.row.resources.map(resource => resource.displayName).join(', ') : '-' }}
          <template v-if="props.row.isAssignmentCustomer">
            {{ $t('components.service.edit.resources.perCustomer') }}
          </template>
          <!--<template v-if="props.row.resources">
            <span v-for="resource in props.row.resources" :key="resource.idEmployee" class="after:content-[',]">
              {{ resource.displayName }}
            </span>
          </template>-->
        </td>
        <td :class="props.tdClass">
          {{ props.row.isDefaultSelectionNone ? $t('resource.none') : $t('components.service.edit.resources.first') }}
        </td>
        <td :class="props.tdClass">
          <div class="flex items-center space-x-1">
            <!--<OTooltip text="Edit">
              <OButton icon="edit" size="sm" @click="handleEditServiceResource(props.row)" />
            </OTooltip>-->
            <OTooltip :text="$t('general.delete')">
              <OButton icon="delete" variant="danger" size="sm" flat @click="handleRemoveServiceResource(props.row)" />
            </OTooltip>
          </div>
        </td>
      </template>
    </OTable>

    <AddServiceResourceModal
      ref="addServiceResourceModal"
      v-model:service="_service"
    />

    <RemoveServiceResourceModal
      ref="removeServiceResourceModal"
      v-model:service="_service"
    />
  </div>
</template>

<script setup lang="ts">
import AddServiceResourceModal from '@/components/service/actions/AddResource.vue'
import RemoveServiceResourceModal from '@/components/service/actions/RemoveResource.vue'

import { OTable, OButton, OTooltip } from '@/components/elements'

import type { Service } from '~/_api/models/service'

// Model bindings
const _service = defineModel<Service>('service')

const serviceResources = computed(() => _service.value?.resources || [])

// Template refs
const addServiceResourceModal = ref()
const removeServiceResourceModal = ref()

// Methods
const handleAddServiceResource = (): void => {
  addServiceResourceModal.value?.open()
}

const handleRemoveServiceResource = (ServiceResource: any): void => {
  removeServiceResourceModal.value?.open(ServiceResource)
}
</script>
